import { Action, ActionType, State } from './types'
import { initialState } from './index'

export function reducer(state: State, action: Action): State {
  switch (action.type) {
    case ActionType.setAsc: {
      return {
        ...state,
        asc: !state.asc,
      }
    }
    case ActionType.setSearch: {
      return {
        ...state,
        search: action.payload,
      }
    }
    case ActionType.setSelectedFolderId: {
      return {
        ...state,
        selectedFolderId: action.payload || null,
      }
    }
    case ActionType.setSortBy: {
      return {
        ...state,
        sortBy: action.payload,
      }
    }
    case ActionType.reset: {
      return { ...initialState }
    }
    case ActionType.setFilteredDatasets: {
      return {
        ...state,
        filteredDatasets: action.payload,
      }
    }
    case ActionType.setSelectedDataset: {
      return {
        ...state,
        selectedDataset: action.payload,
      }
    }
    default:
      return state
  }
}
